var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('footer',{staticClass:"u-footer d-md-flex align-items-md-center text-center text-md-left text-muted"},[_c('ul',{staticClass:"list-inline mb-3 mb-md-0"},[_c('li',{staticClass:"list-inline-item mr-4"})]),_c('span',{staticClass:"text-muted ml-auto"})])])
}]

export { render, staticRenderFns }